import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { GENERIC_MYSQL } from "../../Constants"

function ZdqGenericMySqlConnector() {
    return <ZdqConnectorSetup vendor={GENERIC_MYSQL}></ZdqConnectorSetup>
}

export default ZdqGenericMySqlConnector 